import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable, throwError } from 'rxjs';
import { mergeMap, catchError, finalize } from 'rxjs/operators';
import { LoadingService } from './loading.service';
import { NotificationService } from './notification.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InterceptorService implements HttpInterceptor {
  constructor(
    private auth: AuthService,
    private loderService: LoadingService,
    private notification: NotificationService
  ) {}
  private requests: HttpRequest<any>[] = [];

  addRequest(req: HttpRequest<any>) {
    this.requests.push(req);
    if (
      !this.buttonLoadingMethods.some((a) =>
        req.url.toLowerCase().endsWith(a)
      ) &&
      !req.url.toLocaleLowerCase().includes('/api/files/securelink')
    )
      this.loderService.toggleLoading(this.requests.length > 0);
    this.loderService.toggleButtonLoading(this.requests.length > 0);
  }
  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loderService.toggleLoading(this.requests.length > 0);
    this.loderService.toggleButtonLoading(this.requests.length > 0);
  }
  buttonLoadingMethods = ['/api/files'];
  anonymosMethods = [
    'users/add',
    '/validate',
    'family/invite/',
    'users/initialize',
    'users/features',
    '/contactmessage',
    '/securefileaccess',
    '/getfilelinkstatus',
  ];
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.includes('api')) {
      this.addRequest(req);
    }
    if (!this.auth.loggedIn) {
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
          if (
            error instanceof HttpErrorResponse &&
            environment.environment != 'PROD'
          ) {
            this.notification.showError(
              error.message || error.error.message,
              'Server Error'
            );
          }
          return throwError(error);
        }),
        finalize(() => this.removeRequest(req))
      );
    }
    return this.auth.getTokenSilently$().pipe(
      mergeMap((token) => {
        const tokenReq = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        });
        return next
          .handle(tokenReq)
          .pipe(finalize(() => this.removeRequest(req)));
      }),
      catchError((err) => {
        this.removeRequest(req);
        if (environment.environment != 'PROD')
          this.notification.showError(
            err.message || err.error.message,
            'Server Error'
          );
        return throwError(err);
      })
    );
  }
}
